
<template>
  <div class="video-wrapper">
    <!-- <responsive-video :payload="payload" /> -->
    <video controls v-if="(payload.mp4 && payload.mp4.file) || (payload.webm && payload.webm.file)">
      <source
        :src="resourceUrl + payload.mp4.file.path"
        type="video/mp4"
        v-if="payload.mp4 && payload.mp4.file"
      />
      <source
        :src="resourceUrl + payload.webm.file.path"
        type="video/webm"
        v-if="payload.webm && payload.webm.file"
      />
    </video>
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      default: () => {}
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.video-wrapper {
  video {
    width: 100%;
    height: auto;
  }
}
</style>